import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ICreateBinRequest,
  ICreateBinResponse,
} from '../../models/createBin/createBin.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useCreateBin = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const onCreateBinError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while creating bin'
    );
  };

  const onCreateBinSuccess = ({
    message,
  }: SuccessHttpResponse<ICreateBinResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createBin = (data: ICreateBinRequest) => {
    const url: HttpConfig = {
      url: 'warehouse-service/api/v1/bins',
      method: 'post',
      data,
    };

    request(url, onCreateBinSuccess, setLoading, onCreateBinError);
  };

  return { createBin, loading, resetInputFields };
};

export default useCreateBin;
